export const currencies = [
  { label: "USD", value: "USD" },
  { label: "PKR", value: "PKR" },
  { label: "EUR", value: "EUR" },
  { label: "EGP", value: "EGP" },
];
